import I18n from 'I18n';
import createSingleI18nProvider from 'I18n/init/providers/createSingleI18nProvider';
import getLangLocale from 'I18n/utils/getLangLocale';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { TourUsageTracker } from 'ui-shepherd-tracker/usageTracker';
import { TOUR_I18N_LOADERS } from '../../__generated__/TourI18nLoaders';
import { getStepId } from './tourTransformer';
import { getTourStepContentOverrides } from '../util/tourStorage';
import { jsx as _jsx } from "react/jsx-runtime";
let tourUsageTracker;
const getTourI18nLoader = tourId => {
  const loader = TOUR_I18N_LOADERS[tourId];
  return loader ? {
    load: loader
  } : null;
};
export async function loadTourTranslations(tourId) {
  var _getTourI18nLoader;
  const i18nProvider = createSingleI18nProvider({
    language: getLangLocale()
  });
  await Promise.all([(_getTourI18nLoader = getTourI18nLoader(tourId)) === null || _getTourI18nLoader === void 0 ? void 0 : _getTourI18nLoader.load(), import( /* webpackMode: "eager" */`i2l?query=sporks!../../lang/shared/en.lyaml`)].map(loader => loader === null || loader === void 0 ? void 0 : loader.then(langModule => i18nProvider.register(langModule.default))));
}

/**
 * Given a tour, this function will populate that tour with copy given that the copy is formatted correctly.
 * @param {tourConfig} tour
 */
export const populateTourWithCopy = (tourId, tour) => {
  const {
    i18nPrefix
  } = tour;
  // Ensures the i18n namespace exists and throws an early error, to prevent error reporting to dependent apps
  // @ts-expect-error I18n.lookup is not typed
  if (!I18n.lookup(`onboarding-tours-${i18nPrefix}`)) {
    throw new Error(`Missing translation. Please import lyaml containing namespace: "onboarding-tours-${i18nPrefix}".`);
  }
  if (tour.recommendNextTour) {
    tour.recommendNextTour.title = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.title`);
    tour.recommendNextTour.text = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.text`);
    tour.recommendNextTour.cta = I18n.text(`onboarding-tours-${i18nPrefix}.recommendNextTour.cta`);
  }
  tour.steps.forEach((step, stepIndex) => {
    const stepNumber = stepIndex + 1;
    const tourStepContentOverrides = getTourStepContentOverrides(tourId, `step ${stepNumber}`) || {};
    if (step.text === true) {
      step.text = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `onboarding-tours-${i18nPrefix}.step${stepNumber}.text`,
        options: tourStepContentOverrides.textOptions
      });
    }
    if (step.externalStepLink) {
      step.externalStepComponent = /*#__PURE__*/_jsx(Link, {
        external: true,
        href: step.externalStepLink,
        onClick: () => {
          if (!tourUsageTracker) {
            tourUsageTracker = new TourUsageTracker('onboarding-tours');
          }
          tourUsageTracker.trackTourClickExternalStepLink(tourId, getStepId(stepIndex));
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `onboarding-tours-${i18nPrefix}.step${stepNumber}.externalStepLink`
        })
      });
    }
    if (step.title === true) {
      step.title = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.title`, tourStepContentOverrides.titleOptions);
    }
    if (step.actionText === true) {
      step.actionText = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.actionText`);
    }
    if (step.buttons) {
      step.buttons.forEach((button, buttonIndex) => {
        const buttonNumber = buttonIndex + 1;
        if (button.text === true) {
          button.text = I18n.text(`onboarding-tours-${i18nPrefix}.step${stepNumber}.button${buttonNumber}`);
        } else if (typeof button.commonText === 'string') {
          button.text = I18n.text(`onboarding-tours-common.button.${button.commonText}`);
        }
      });
    }
  });
  return tour;
};